import { Injectable } from '@angular/core';
import { PartnersTypeaheadService } from './partners-typeahead-service';
import { PartnerService } from './partner.service';

@Injectable({
  providedIn: 'root',
})
export class PlaceOfTakingOverTypeaheadServiceService extends PartnersTypeaheadService {
  constructor(partnerService: PartnerService) {
    super(partnerService);
  }

  name(): string {
    return 'placeOfTakingOver';
  }
}
